const en_US = {
  title: 'Single Sign-On Management',
};
export default en_US;
